// Copyright (c) 2020 Deere & Company

import {combineReducers} from 'redux';
import {getCombinedReducers as getCombinedSearchReducers} from './search/reducers';
import {getCombinedReducers as getCombinedSearchResultsReducers} from './rga-search-results/reducers';
import {getCombinedReducers as getCombinedSharedReducers} from './shared/rga-domain-values/reducers';
export const getCombinedReducers = () => combineReducers({
    search: getCombinedSearchReducers(),
    searchResults: getCombinedSearchResultsReducers(),
    shared: getCombinedSharedReducers()
});



// WEBPACK FOOTER //
// ./src/rga/rga-reducers.js